import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { FormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import {
   MatButtonModule,
   MatToolbarModule,
   MatIconModule,
   MatBadgeModule,
   MatSidenavModule,
   MatListModule,
   MatGridListModule,
   MatFormFieldModule,
   MatInputModule,
   MatSelectModule,
   MatRadioModule,
   MatDatepickerModule,
   MatNativeDateModule,
   MatChipsModule,
   MatTooltipModule,
   MatTableModule,
   MatPaginatorModule,
   MatSlideToggleModule,
   MatSnackBarModule,
   MatProgressSpinnerModule,
   MatCheckboxModule,
   MatAutocompleteModule,
   MatCardModule,
   MatAccordion
} from '@angular/material';

@NgModule({
   imports: [
      CommonModule,
      MatButtonModule,
      MatToolbarModule,
      MatIconModule,
      MatSidenavModule,
      MatBadgeModule,
      MatListModule,
      MatGridListModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatRadioModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatChipsModule,
      MatTooltipModule,
      MatTableModule,
      MatPaginatorModule,
      MatSlideToggleModule,
      //FormsModule,
      MatSnackBarModule,
      MatProgressSpinnerModule,
      MatCheckboxModule,
      MatAutocompleteModule,
      NgxMatSelectSearchModule,
      MatCardModule
   ],
   exports: [
      MatButtonModule,
      MatToolbarModule,
      MatIconModule,
      MatSidenavModule,
      MatBadgeModule,
      MatListModule,
      MatGridListModule,
      MatInputModule,
      MatFormFieldModule,
      MatSelectModule,
      MatRadioModule,
      MatDatepickerModule,
      MatChipsModule,
      MatTooltipModule,
      MatTableModule,
      MatPaginatorModule,
      MatSlideToggleModule,
      //FormsModule,
      MatSnackBarModule,
      MatProgressSpinnerModule,
      MatCheckboxModule,
      MatAutocompleteModule,
      NgxMatSelectSearchModule,
      MatCardModule
   ],
   providers: [
      MatDatepickerModule,
      //FormsModule
   ]
})

export class AngularMaterialModule { }
